import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import userPlaceholder from 'assets/img/icon-user.svg';

function DashboardListCard({ data, className }) {
  return (
    <div className={`dashboard-card ${className}`}>
      <div className="row">
        <div className="col-12 mb-3 d-flex">
          <div>
            <div className="main-text">{_.get(data, 'label')}</div>
            <div className="label-lg">{_.get(data, 'total')}</div>
          </div>
          <div className="ml-auto dashboard-card-icon">
            <img
              className=""
              src={_.get(data, 'photo', userPlaceholder)}
              alt=""
            />
          </div>
        </div>

        <div className="col-12">
          {_.get(data, 'list', []).map(item => (
            <div key={item.label}>
              <div className="d-flex justify-content-between">
                <label className="sub-text m-0">{_.get(item, 'label', '')}</label>
                <div className="font-weight-bold">{_.get(item, 'value', '')}</div>
              </div>
              <div className={`bottom-border ${_.get(item, 'borderClassName', 'primary')}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
DashboardListCard.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  className: PropTypes.string,
}
DashboardListCard.defaultProps = {
  className: '',
}

export default DashboardListCard;
